// src/api/contact.js
import apiClient from './client';

/**
 * Submit contact form
 * @param {Object} contactData - Contact form data
 * @returns {Promise} Promise with response data
 */
export const submitContactForm = async (contactData) => {
  try {
    // Make sure the contactData only contains the exact fields expected by the API
    const sanitizedData = {
      name: contactData.name,
      email: contactData.email,
      mobile: contactData.mobile || null,
      service_type: contactData.service_type || null,
      subject: contactData.subject,
      message: contactData.message
    };
    
    // Send data directly as the backend expects ContactCreate model directly
    const response = await apiClient.post('/contact', sanitizedData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get all contact submissions (requires authentication)
 * @returns {Promise} Promise with array of contact submissions
 */
export const getContactSubmissions = async () => {
  try {
    const response = await apiClient.get('/contact');
    return response.data;
  } catch (error) {
    throw error;
  }
};